<div class="ag-grid-table-container">
  @if (enableRtl()) {
    <ng-container *ngTemplateOutlet="agTableTemplate" />
  } @else {
    <ng-container *ngTemplateOutlet="agTableTemplate" />
  }
</div>

<ng-template #agTableTemplate>
    <ag-grid-angular
      class="ag-grid-table"
      [enableRtl]="enableRtl()"
      [rowSelection]="rowSelection()"
      [theme]="theme"
      [columnDefs]="colDefs()"
      [defaultColDef]="defaultColDef"
      [localeText]="localeText()"
      [icons]="icons"
      [suppressDragLeaveHidesColumns]="true"
      [suppressMoveWhenColumnDragging]="true"
      [tooltipShowMode]="tooltipShowMode()"
      [selectionColumnDef]="selectionColumnDef"
      [sideBar]="sideBar()"
      [rowModelType]="rowModelType"
      [getRowId]="getRowId"
      [serverSideDatasource]="dataSource()"
      (selectionChanged)="onRowSelectionChanged($event)"
      (columnVisible)="onColumnVisible()"
      (gridReady)="onGridReady($event)"
      (firstDataRendered)="onFirstDataRendered()"
      (cellClicked)="onCellClicked($event)"
    />
</ng-template>
